import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Laboratory } from '../models/lab/laboratory.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class OmLaboratoryService extends RequestService<Laboratory> {
  static PATH = '/om/laboratory';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, OmLaboratoryService.PATH, globalService.debugUrl);
  }
}
